module.exports = __WEBPACK_EXTERNAL_MODULE_13__;


//////////////////
// WEBPACK FOOTER
// external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react","umd":"react"}
// module id = 13
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react","umd":"react"}